
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire18e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire18e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iIuFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $da041f39a5c80e7c$export$2e2bcd8739ae039);
function $da041f39a5c80e7c$export$2e2bcd8739ae039() {
    let offlineMsgDiv = document.createElement("div");
    offlineMsgDiv.id = "offlineMessage";
    offlineMsgDiv.style.top = 0;
    offlineMsgDiv.style.width = "100%";
    offlineMsgDiv.style.backgroundColor = "red";
    offlineMsgDiv.style.color = "white";
    offlineMsgDiv.style.textAlign = "center";
    offlineMsgDiv.style.padding = "10px";
    offlineMsgDiv.textContent = "Looks like you are offline. Please check your internet connection, and try again later.";
    return offlineMsgDiv;
}

});


var $iIuFd = parcelRequire("iIuFd");
window.addEventListener("offline", ()=>{
    let body = document.querySelector("body");
    const offlineMsgDiv = (0, $iIuFd.default)();
    body.insertBefore(offlineMsgDiv, body.firstChild);
    document.getElementById("main-container").classList.add("disabled");
});
window.addEventListener("online", ()=>{
    document.getElementById("offlineMessage").remove();
    document.getElementById("main-container").classList.remove("disabled");
});


//# sourceMappingURL=index.ce0ea393.js.map
